// Apps
export enum AppEnum {
  NIGEL = 'NIGEL',
  AI_STORE = 'AI_STORE',
  DEAL_GPT = 'DEAL_GPT',
  ENERGY_UTILITIES_DEMO = 'ENERGY_AND_UTILITIES_DEMO',
  WM_EMPLOYEE_HANDBOOK = 'WM_EMPLOYEE_HANDBOOK',
  INTELLIO_INSIGHTS = 'INTELLIO_INSIGHTS',
  AI_MOMENTUM = 'AI_MOMENTUM',
}

export const AppNameBannerMap = {
  [AppEnum.NIGEL]: 'Nigel',
  [AppEnum.AI_STORE]: 'AI Store',
  [AppEnum.DEAL_GPT]: 'Intellio® Advantage',
  [AppEnum.ENERGY_UTILITIES_DEMO]: 'OGC Assist',
  [AppEnum.WM_EMPLOYEE_HANDBOOK]: 'Employee Handbook',
  [AppEnum.INTELLIO_INSIGHTS]: 'Intellio® Insights',
  [AppEnum.AI_MOMENTUM]: 'My AI Momentum',
};

// Conversations
export enum MessageFrom {
  AI = 'AI',
  USER = 'USER',
}

// Users
export enum UserRole {
  ADMIN = 'ADMIN',
  DEALGPT_ADMIN = 'DEALGPT_ADMIN',
}

export enum FolderView {
  CHATS = 'CHATS',
  PROMPTS = 'PROMPTS',
  DISCOVERY = 'DISCOVERY',
  DATA_PROCESSING = 'DATA_PROCESSING',
  DATA_REQUEST_LIST = 'DATA_REQUEST_LIST',
  ANALYSIS = 'ANALYSIS',
  FILES = 'FILES',

  // Hidden views
  CHAT = 'CHAT',
  EDIT = 'EDIT',
  CONFIG = 'CONFIG',
  SCOPE_AREAS = 'SCOPE_AREAS',
}

export const FolderViewConfig: Record<
  FolderView,
  {
    label: string;
    path: string;
    order: number;
  }
> = {
  [FolderView.CHATS]: { label: 'Chat', path: '', order: 1 },
  [FolderView.PROMPTS]: { label: 'Prompts', path: 'prompts', order: 2 },
  [FolderView.DATA_REQUEST_LIST]: {
    label: 'Data Request List',
    path: 'data-request-list',
    order: 3,
  },
  [FolderView.DISCOVERY]: { label: 'Discovery', path: 'discovery', order: 4 },
  [FolderView.DATA_PROCESSING]: { label: 'Data', path: 'data', order: 5 },
  [FolderView.ANALYSIS]: { label: 'Analysis', path: 'analysis', order: 6 },
  [FolderView.FILES]: { label: 'Files', path: 'files', order: 7 },

  // Internal views (still need paths + labels because router uses them)
  [FolderView.CHAT]: { label: 'Chat', path: '', order: 100 },
  [FolderView.EDIT]: { label: 'Edit', path: 'edit', order: 101 },
  [FolderView.CONFIG]: { label: 'Configure', path: 'configure', order: 102 },
  [FolderView.SCOPE_AREAS]: { label: 'Scope Areas', path: 'analysis', order: 103 },
};

// Files
export enum FileUploadMimeType {
  PLAIN_TEXT = 'text/plain',
  MARKDOWN = 'text/markdown',
  MS_WORD_DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
}

export enum FileView {
  USER = 'USER',
  FOLDER = 'FOLDER',
  PROMPT = 'PROMPT',
  PROJECT = 'PROJECT',
}

export enum FilesTabs {
  UPLOADED = 'UPLOADED_FILES',
  INDEXED = 'INDEXED_FILES',
  GRAPH_RAG_VISUALIZATION = 'GRAPH_RAG_VISUALIZATION',
}

export enum ToolName {
  DEEP_RESEARCH = 'deepResearch',
  WEB_SEARCH = 'webSearch',
  GLEAN_SEARCH = 'gleanSearch',
  STRACL_MCP = 'straclMcp',
  SEARCH_SHAREPOINT_FILES = 'searchSharepointFiles',
  SEARCH_SHAREPOINT_SITES = 'searchSharepointSites',
  SEARCH_SHAREPOINT_FOLDERS = 'searchSharepointFolders',
  SEARCH_INTELLIO_DATA = 'searchIntellioInsightsInfrastructureRubricData',
  SEARCH_INTELLIO_MCS_MODEL_LINE_DETAILS = 'searchIntellioInsightsMcsModelLineDetails',
  SEARCH_INTELLIO_MCS_SUMMARY_DATA = 'searchIntellioInsightsMcsSummaryData',
  SEARCH_INTELLIO_KPI_LIST = 'searchIntellioInsightsKpiList',
  SEARCH_INTELLIO_MA_GENAI_DILIGENCE_SSA_DETAIL = 'searchIntellioInsightsMaGenaiDiligenceSsaDetail',
  SEARCH_INTELLIO_MA_GENAI_DILIGENCE_SSA_AGGREGATE = 'searchIntellioInsightsMaGenaiDiligenceSsaAggregate',
  SEARCH_INTELLIO_SCHEMAS = 'searchIntellioSchemas',
  SEARCH_INTELLIO_QUERY = 'searchIntellioQuery',
}

export enum PromptSortOptions {
  DEFAULT = 'DEFAULT',
  LIKES = 'LIKES',
  USAGE = 'USAGE',
  UPDATEDAT = 'UPDATEDAT',
  CREATEDAT = 'CREATEDAT',
}

export enum PromptTableSortOptions {
  TITLE = 'TITLE',
  DESCRIPTION = 'DESCRIPTION',
  CREATEDBY = 'CREATEDBY',
}

export enum PromptStage {
  READY = 'Ready',
  IN_PROGRESS = 'In Progress',
  IDEA = 'Idea',
  LEGACY = 'Legacy',
}

export enum SolutionType {
  PROMPT = 'Prompt',
  WORKFLOW = 'Workflow',
  APP = 'App',
  SKILL = 'Skill',
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

// Admin
export enum AdminTab {
  USER_STATS = 'USER_STATS',
  USER_REQUEST_PANEL = 'USER_REQUEST_PANEL',
}

export enum DealGPTView {
  DISCOVERY = 'DISCOVERY',
  DATA_PROCESSING = 'DATA_PROCESSING',
  DATA_REQUEST_LIST = 'DATA_REQUEST_LIST',
  ANALYSIS = 'ANALYSIS',
  CHAT = 'CHAT',
  SCOPE_AREAS = 'SCOPE_AREAS',
}

export enum ProjectConfigView {
  CONFIG = 'CONFIG',
  KPI = 'KPI',
}

export enum AnalysisKPIQuestionType {
  NUMERIC = 'NUMERIC',
  LOOKUP_LIST = 'LOOKUP_LIST',
  TEXT = 'TEXT',
  BOOLEAN = 'BOOLEAN',
}

export enum DealGPTDiscoveryView {
  ALL_QUESTIONS = 'ALL_QUESTIONS',
  SITE_VISIT_PREP = 'SITE_VISIT_PREP',
  KEY_QUESTION_SUMMARY = 'KEY_QUESTION_SUMMARY',
}

export enum DealGPTQuestionStatus {
  PENDING = 'PENDING',
  ANSWERED = 'ANSWERED',
  MORE_INFO_NEEDED = 'MORE_INFO_NEEDED',
  NOT_FOUND = 'NOT_FOUND',
  ERROR = 'ERROR',
  SKIPPED = 'SKIPPED',
}

export enum IntellioAdvTone {
  MORE_POSITIVE = 'MORE_POSITIVE_TONE',
  MORE_NEUTRAL = 'MORE_NEUTRAL_TONE',
  MORE_CRITICAL = 'MORE_CRITICAL_TONE',
  MORE_DETAILED = 'MORE_DETAILED_TONE',
  SIMPLIFY_LANGUAGE = 'SIMPLIFY_LANGUAGE_TONE',
  MORE_CONCISE = 'MORE_CONCISE_TONE',
}

export const IntellioAdvToneDisplayMap: Record<IntellioAdvTone, string> = {
  [IntellioAdvTone.MORE_POSITIVE]: 'More Positive',
  [IntellioAdvTone.MORE_NEUTRAL]: 'More Neutral',
  [IntellioAdvTone.MORE_CRITICAL]: 'More Critical',
  [IntellioAdvTone.MORE_DETAILED]: 'More Detailed',
  [IntellioAdvTone.SIMPLIFY_LANGUAGE]: 'Simplify Language',
  [IntellioAdvTone.MORE_CONCISE]: 'More Concise',
};

export enum UpdatedReason {
  USER_EDIT = 'USER_EDIT',
  TONE_CHANGE = 'TONE_CHANGE',
  REPROCESS = 'REPROCESS',
  INITIAL = 'INITIAL',
  USER_INPUT = 'USER_INPUT',
}

export enum ProcessReason {
  PROCESS_THIS = 'PROCESS_THIS',
  APPLY_CHANGES = 'APPLY_CHANGES',
  PROCESS_THIS_AND_APPLY_CHANGES = 'PROCESS_THIS_AND_APPLY_CHANGES',
}

export enum AnalysisQuestionType {
  PROMPT_ANSWER = 'PROMPT_ANSWER',
  QUESTION_AND_ANSWER = 'QUESTION_AND_ANSWER',
  KPI = 'KPI',
  RUBRIC = 'RUBRIC',
  NOTES = 'NOTES',
  BENCHMARK = 'BENCHMARK',
}

export enum ProjectStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export enum ProjectConfigStatus {
  COMPLETE = 'COMPLETE',
  INCOMPLETE = 'INCOMPLETE',
}

export enum IndexType {
  OPENAI = 'OPENAI',
  GRAPH_RAG = 'GRAPH_RAG',
}

export enum VectorStoreStatus {
  CREATED = 'CREATED',
  READY = 'READY',
  INDEXING = 'INDEXING',
}

export enum RunType {
  DISCOVERY = 'DISCOVERY',
  ANALYSIS = 'ANALYSIS',
  PROJECT = 'PROJECT',
  DATA_PROCESSING = 'DATA_PROCESSING',
  DATA_REQUEST_LIST = 'DATA_REQUEST_LIST',
  PROMPT_KICKOFF = 'PROMPT_KICKOFF',
}

export enum ScopeAreasStatus {
  NOT_STARTED = 'NOT STARTED',
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN PROGRESS',
  COMPLETE = 'COMPLETE',
}

export enum FeedbackOptions {
  NOT_ENOUGH_INFORMATION = 'Not Enough Information',
  TOO_VAGUE = 'Too Vague',
  UNHELPFUL = 'Unhelpful',
  BEING_LAZY = 'Being Lazy',
  INACCURATE_FALSE_INFORMATION = 'Inaccurate/False Information',
  SLOW_RESPONSE_TIME = 'Slow Response Time',
  WRONG_TONE = 'Wrong Tone',
  INCORRECT_CONTEXT = 'Incorrect Context',
  INCORRECT_FALSE_INFORMATION = 'Incorrect/False Information',
  INCOMPLETE_ANSWER = 'Incomplete Answer',
  IRRELEVANT_ANSWER = 'Irrelevant Answer',
  OUTDATED_INFORMATION = 'Outdated Information',
  UNCLEAR_CONFUSING = 'Unclear/Confusing',
  TECHNICAL_ISSUES = 'Technical Issues',
}

export enum AnalysisQuestionStatus {
  ANSWERED = 'ANSWERED',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  INITIAL = 'INITIAL',
  INPUT_PENDING = 'INPUT_PENDING',
  NOT_FOUND = 'NOT_FOUND',
  NEEDS_CONFIRMATION = 'NEEDS_CONFIRMATION',
  CONFIRMED = 'CONFIRMED',
}

export enum CollectionTags {
  VERIFIED = 'Verified',
  AI_VALUE_ADD_ON = 'AI Value Add-On',
  APPSEC = 'AppSec',
  CAPE = 'CAPE',
  C_AND_IP_BACK_OFFICE = 'C&IP - M&D Back Office',
  C_AND_IP_CORE_OPERATIONS = 'C&IP - M&D Core Operations',
  CORPORATE_INFRASTRUCTURE = 'Corporate Infrastructure',
  CYBERSECURITY = 'Cybersecurity',
  CYBERSECURITY_WATER_UTILITIES = 'Cybersecurity for Water Utilities',
  DATA_ENGINEERING_AND_ANALYTICS = 'Data Engineering & Analytics',
  E_AND_U_CYBERSECURITY = 'E&U - Cybersecurity',
  HLS = 'HLS',
  HTS = 'HT&S',
  INSURANCE = 'Insurance',
  OPC_HR_DUE_DILIGENCE = 'OPC - HR Due Diligence',
  PRODUCT_MANAGEMENT = 'Product Management',
  SDLC = 'SDLC',
  SERVICE_STRATEGY = 'Service Strategy',
  SOFTWARE_ARCHITECTURE = 'Software Architecture',
  TECHNOLOGY_CARVEOUT = 'Technology Carveout',
  TECHNOLOGY_SPEND = 'Technology Spend',
  TECHNOLOGY_TEAM = 'Technology Team',
  C_AND_IP_PROFESSIONAL_SERVICES = 'C&IP - Prof. Services',
  IT_CARVEOUT_COMPLEXITY = 'IT Carveout Complexity',
}

export enum Commentable {
  Prompt = 'Prompt',
  DataRequestItem = 'DataRequestItem',
}

export enum BenchmarkOptionType {
  Overall = 'overall',
  Industry = 'industry',
  Subindustry = 'subindustry',
  Revenue = 'revenue',
}

export enum PromptDrawerMode {
  Builder = 'builder',
  Create = 'create',
  StepByStep = 'stepByStep',
  Edit = 'edit',
}

export enum PromptBuilderMode {
  FULL = 'FULL',
  EXTERNAL_ONLY = 'EXTERNAL_ONLY',
  INTERNAL_ONLY = 'INTERNAL_ONLY',
}

export enum PromptSuggestionStep {
  ROLE = 'ROLE',
  GOAL = 'GOAL',
  KNOWLEDGE = 'KNOWLEDGE',
  OUTPUT = 'OUTPUT',
  TONE = 'TONE',
}

export enum SemaScanType {
  TWO_STEP = 'TWO_STEP',
  FULL = 'FULL_STEP',
}

export enum SemaFileCategory {
  PPTX = 'PPTX',
  IPRISK_EXCEL = 'IPRISK_EXCEL',
  SECURITY_WARNING_EXCEL = 'SECURITY_WARNING_EXCEL',
  INVALID = 'INVALID',
}

export enum CraftFeedbackType {
  REQUEST = 'Request',
  BUG = 'Bug',
}

export enum CraftCategory {
  NIGEL = '2305843010557537904',
  IA = '2305843010557540154',
}

export enum CraftLabel {
  REQUEST = 'Feature Request',
  BUG = 'Bug Report',
}

export enum UserRequestType {
  DEEP_RESEARCH_CREDIT_REQUEST = 'DEEP_RESEARCH_CREDIT_REQUEST',
  APP_APPROVAL_REQUEST = 'APP_APPROVAL_REQUEST',
}

export enum UserRequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
}

export enum NotificationType {
  DEEP_RESEARCH_STARTED = 'DEEP_RESEARCH_STARTED',
  DEEP_RESEARCH_COMPLETED = 'DEEP_RESEARCH_COMPLETED',
  DEEP_RESEARCH_FAILED = 'DEEP_RESEARCH_FAILED',
  DEEP_RESEARCH_REFILL_REQUEST = 'DEEP_RESEARCH_REFILL_REQUEST',
  DEEP_RESEARCH_REFILL_APPROVED = 'DEEP_RESEARCH_REFILL_APPROVED',
  DEEP_RESEARCH_REFILL_DENIED = 'DEEP_RESEARCH_REFILL_DENIED',
  APP_APPROVAL_REQUEST = 'APP_APPROVAL_REQUEST',
  APP_USER_APPROVAL_SENT = 'APP_USER_APPROVAL_SENT',
  APP_USER_APPROVAL_APPROVED = 'APP_USER_APPROVAL_APPROVED',
  APP_USER_APPROVAL_DENIED = 'APP_USER_APPROVAL_DENIED',
  FOLDER_SHARED = 'FOLDER_SHARED',
  PROMPT_SHARED = 'PROMPT_SHARED',
  INDEXING_COMPLETED = 'INDEXING_COMPLETED',
  DISCOVERY_COMPLETED = 'DISCOVERY_COMPLETED',
  ANALYSIS_COMPLETED = 'ANALYSIS_COMPLETED',
}

export enum KpiSource {
  LLM = 'LLM',
  Database = 'Database',
}

export enum PromptLocation {
  PROMPTS_PAGE,
  FEATURED_PROMPTS,
  PROMPT_LIST,
}

export enum FiltersDisplayMode {
  LIST,
  DROPDOWN,
}

export enum DrawerTypes {
  SINGLE_PROMPT,
  PROMPT_LIST,
}

export enum DataRequestListView {
  OVERVIEW = 'Overview',
  COMMENTS = 'Comments',
  HISTORY = 'History',
}

export enum DataRequestItemStatus {
  OPEN = 'Open',
  PARTIAL = 'Partial',
  COMPLETE = 'Complete',
}

export enum DataRequestItemPriority {
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
}

export enum ChatMode {
  DISCOVERY = 'discovery',
  ANALYSIS = 'analysis',
}

export enum ChatDrawerActiveTab {
  DISCOVERY = 'discovery',
  ANALYSIS = 'analysis',
}

export enum ProjectRunStatus {
  // Discovery
  READY_FOR_PROCESSING = 'Ready for Processing',
  INSERTING_QUESTIONS = 'Inserting Questions',
  PROCESSING_QUESTIONS = 'Processing Questions',
  COMPLETED_SUCCESSFULLY = 'Completed Successfully',
  // Analysis
  CURRENTLY_SCANNING = 'Currently Scanning',
  COMPLETED_SCANNING = 'Completed Scanning',
  // Data Request List
  INDEXING = 'Indexing',
  DISCOVERY = 'Discovery',
  MISSING_ = 'Missing Discovery',
}

export enum ConversationType {
  AUTOSTART_PROMPT = 'AUTOSTART_PROMPT',
}

export enum CardSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  FULL = 'FULL',
}

export enum PaginationMode {
  REPLACE = 'replace',
  APPEND = 'append',
}

export enum PromptView {
  ALL_PROMPTS = 'ALL_PROMPTS',
  RECENT = 'RECENT',
  PINNED = 'PINNED',
  MY_PINNED = 'MY_PINNED',
  MY_PROMPTS = 'MY_PROMPTS',
  SHARED = 'SHARED',
  ARCHIVED = 'ARCHIVED',
}

export enum PromptViewUrl {
  ALL_PROMPTS = '',
  RECENT = 'recent',
  SHARED = 'shared',
  MY_PINNED = 'my-pinned',
  ARCHIVED = 'archived',
  MY_PROMPTS = 'my-prompts',
  PINNED = 'pinned',
}

export const PromptViewConfig: Record<
  PromptView,
  {
    publishedOnly?: boolean;
    myPromptsOnly?: boolean;
    recent: boolean;
    pinned?: boolean;
    folderPinned?: boolean;
    archivedOnly?: boolean;
  }
> = {
  [PromptView.ALL_PROMPTS]: {
    publishedOnly: true,
    recent: false,
  },
  [PromptView.RECENT]: {
    recent: true,
  },
  [PromptView.PINNED]: {
    recent: false,
    folderPinned: true,
  },
  [PromptView.MY_PINNED]: {
    recent: false,
    pinned: true,
  },
  [PromptView.MY_PROMPTS]: {
    publishedOnly: false,
    recent: false,
    myPromptsOnly: true,
  },
  [PromptView.SHARED]: {
    recent: false,
  },
  [PromptView.ARCHIVED]: {
    recent: false,
    archivedOnly: true,
  },
};

export const UrlToPromptViewMap = {
  [PromptViewUrl.ALL_PROMPTS]: PromptView.ALL_PROMPTS,
  [PromptViewUrl.RECENT]: PromptView.RECENT,
  [PromptViewUrl.SHARED]: PromptView.SHARED,
  [PromptViewUrl.MY_PINNED]: PromptView.MY_PINNED,
  [PromptViewUrl.ARCHIVED]: PromptView.ARCHIVED,
  [PromptViewUrl.MY_PROMPTS]: PromptView.MY_PROMPTS,
  [PromptViewUrl.PINNED]: PromptView.PINNED,
};

export const PromptViewToUrlMap: { [key in PromptView]: PromptViewUrl } = {
  [PromptView.ALL_PROMPTS]: PromptViewUrl.ALL_PROMPTS,
  [PromptView.RECENT]: PromptViewUrl.RECENT,
  [PromptView.SHARED]: PromptViewUrl.SHARED,
  [PromptView.MY_PINNED]: PromptViewUrl.MY_PINNED,
  [PromptView.ARCHIVED]: PromptViewUrl.ARCHIVED,
  [PromptView.MY_PROMPTS]: PromptViewUrl.MY_PROMPTS,
  [PromptView.PINNED]: PromptViewUrl.PINNED,
};

export enum EventType {
  DISCOVERY_COMPLETED = 'Discovery Completed',
  INDEXING_COMPLETED = 'Indexing Completed',
  DRL_ROW_UPDATE = 'DRL Row Update',
}

export const dataRequestItemStatusColors: Record<DataRequestItemStatus, string> = {
  [DataRequestItemStatus.OPEN]: '#F52C00',
  [DataRequestItemStatus.PARTIAL]: '#FFC700',
  [DataRequestItemStatus.COMPLETE]: '#1DD566',
};

export enum contentGenerationAnalysisPages {
  SLIDE_DETAILS = 'Slide Details',
  SLIDE_TITLE = 'Slide Title',
  EXECUTIVE_SUMMARY = 'Executive Summary',
}

export enum HistoryViewMode {
  DETAILED = 'DETAILED',
  COMPACT = 'COMPACT',
}

export enum EventSource {
  PROJECT = 'Project',
  DATA_REQUEST_ITEM = 'DataRequestItem',
}

export enum GraphDocStatus {
  COMPLETED = 'completed',
  PROCESSING = 'processing',
  FAILED = 'failed',
  PENDING = 'pending',
}

export enum SvgIconStatus {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}
